var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 54.6893C18.625 54.6893 17.4483 54.139 16.47 53.0384C15.49 51.9359 15 50.6112 15 49.0643V20.4471C15 19.6971 15.1358 18.9818 15.4075 18.3012C15.6775 17.6224 16.0417 17.0252 16.5 16.5096L30.0625 1.32212C30.6875 0.665866 31.4275 0.267428 32.2825 0.126803C33.1358 -0.0138221 33.9583 0.15024 34.75 0.61899C35.5417 1.08774 36.1142 1.74399 36.4675 2.58774C36.8225 3.43149 36.8958 4.29868 36.6875 5.1893L33.875 18.1268H47.5C48.8333 18.1268 50 18.6893 51 19.8143C52 20.9393 52.5 22.2518 52.5 23.7518V29.3768C52.5 29.7049 52.4683 30.0565 52.405 30.4315C52.3433 30.8065 52.25 31.1581 52.125 31.4862L44.625 51.3143C44.25 52.2518 43.625 53.0487 42.75 53.7049C41.875 54.3612 40.9583 54.6893 40 54.6893H20ZM5 54.6893C3.625 54.6893 2.44833 54.139 1.47 53.0384C0.49 51.9359 0 50.6112 0 49.0643V23.7518C0 22.2049 0.49 20.8802 1.47 19.7777C2.44833 18.6771 3.625 18.1268 5 18.1268C6.375 18.1268 7.55167 18.6771 8.53 19.7777C9.51 20.8802 10 22.2049 10 23.7518V49.0643C10 50.6112 9.51 51.9359 8.53 53.0384C7.55167 54.139 6.375 54.6893 5 54.6893Z",
    fill: "#FFCB41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeUp);
export default __webpack_public_path__ + "static/media/likeUp.0338a4855840bd7ee15a6d307689d45e.svg";
export { ForwardRef as ReactComponent };